<template>
  <v-card width="100%" class="modern-card" elevation="0">
    <apexchart width="100%" height="400" type="bar" :options="chartOptions" :series="series"></apexchart>
  </v-card>
</template>

<script>
export default {
  props: {
    title_header: {
      type: String,
      default: "Chart Title",
    },
    data: {
      type: Object,
      default: () => ({ label: [], series: [] }),
    },
    colors: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    series: [
      {
        name: "Value",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        id: "vuechart-example",
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const label = config.w.config.xaxis.categories[config.dataPointIndex];
            const value = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
            this.$emit("selection", { label, value });
          },
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
          },
        },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
      },
      plotOptions: {
        bar: {
          distributed: false,
          borderRadius: 8,
          columnWidth: "60%",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          if (val >= 1000000) {
            const millions = val / 1000000;
            return millions >= 10 ? `${millions.toFixed(0)}m` : `${millions.toFixed(1)}m`;
          } else if (val >= 1000) {
            const thousands = val / 1000;
            return thousands >= 10 ? `${thousands.toFixed(0)}k` : `${thousands.toFixed(1)}k`;
          } else {
            return val.toFixed(0);
          }
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Roboto, sans-serif",
          },
          rotate: -45,
          rotateAlways: false,
          trim: true,
          maxHeight: 120,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: "Value",
          style: {
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Roboto, sans-serif",
          },
        },
        labels: {
          formatter: function (val) {
            if (val >= 1000000) {
              const millions = val / 1000000;
              return millions >= 10 ? `${millions.toFixed(0)}m` : `${millions.toFixed(1)}m`;
            } else if (val >= 1000) {
              const thousands = val / 1000;
              return thousands >= 10 ? `${thousands.toFixed(0)}k` : `${thousands.toFixed(1)}k`;
            } else {
              return val.toFixed(0);
            }
          },
          style: {
            fontSize: "12px",
            fontFamily: "Roboto, sans-serif",
          },
        },
      },
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#FF4560",
        "#775DD0",
        "#546E7A",
        "#26a69a",
        "#D10CE8",
      ],
      tooltip: {
        y: {
          formatter: function (val) {
            return val.toLocaleString("en-US", {
              style: "decimal",
              maximumFractionDigits: 0,
            });
          },
        },
      },
      grid: {
        borderColor: "#e0e0e0",
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 10,
        },
      },
    },
  }),

  watch: {
    data: {
      handler: function (newValue) {
        this.updateChartData(newValue);
      },
      deep: true,
      immediate: true,
    },
    colors: {
      handler: function (newValue) {
        this.chartOptions.plotOptions.bar.distributed = newValue;
      },
      immediate: true,
    },
    title_header: {
      handler: function (newValue) {
        this.chartOptions.title = {
          text: newValue,
          align: "center",
          style: {
            fontSize: "20px",
            fontWeight: "bold",
            fontFamily: "Roboto, sans-serif",
            color: "#263238",
          },
        };
      },
      immediate: true,
    },
  },

  methods: {
    updateChartData(newData) {
      this.chartOptions.xaxis.categories = newData.label;
      this.series[0].data = newData.series;
    },
  },
};
</script>

<style scoped>
.modern-card {
  background-color: #FFFFFF !important;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  padding: 16px;
}
</style>
